module.exports = __webpack_public_path__ + "img/historial_clinico_gris.ddd256d1.svg";